import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { 
  View, Text, TouchableOpacity, StyleSheet, Modal, 
  FlatList, Alert, TextInput, ScrollView, Dimensions, StatusBar, Platform, ActivityIndicator 
} from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { useVehicles, KATEGORILER, HIZMETLER } from '../context/VehicleContext';
import CustomAlert from '../components/CustomAlert';

const { width } = Dimensions.get('window');

// --- RENK PALETİ ---
const COLORS = {
  primary: '#2563eb',       
  primaryDark: '#1e3a8a',   
  secondaryText: '#64748b', 
  darkText: '#0f172a',      
  background: '#f8fafc',    
  cardBg: '#ffffff',        
  border: '#e2e8f0',        
  plateBg: '#1e293b',       
  plateAccent: '#f59e0b',   
  danger: '#ef4444',        
  keyboardBg: '#cfd8dc',    
  keyBg: '#ffffff',         
};

// --- OPTİMİZE EDİLMİŞ TUŞ BİLEŞENİ (AddScreen Dışında Tanımlanmalı) ---
const KeyButton = React.memo(({ k, widthPercentage = 9, isDelete = false, onPress }) => (
  <TouchableOpacity 
    style={[styles.keyButton, { width: `${widthPercentage}%` }, isDelete && {backgroundColor: '#b0bec5'}]} 
    onPress={onPress}
    delayPressIn={0}
    activeOpacity={0.3}
  >
    {isDelete ? (
      <Ionicons name="backspace" size={22} color={COLORS.darkText} />
    ) : (
      <Text style={styles.keyText}>{k}</Text>
    )}
  </TouchableOpacity>
));

export default function AddScreen({ navigation }) {
  const { fiyatListesi, personelListesi, socketRef, veritabaniniGuncelle,verileriYenile } = useVehicles();
  const insets = useSafeAreaInsets();

  // --- STATE ---
  const [plaka, setPlaka] = useState('');
  const [seciliTur, setSeciliTur] = useState(null);       
  const [seciliHizmet, setSeciliHizmet] = useState(null); 
  const [seciliPersonel, setSeciliPersonel] = useState(null); 
  const [telefon, setTelefon] = useState('');
  const [modalVisible, setModalVisible] = useState(null); 

  const [alertConfig, setAlertConfig] = useState({
    visible: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: () => {},
    showCancel: false
  });

  // Veritabanını kontrol et
  useEffect(() => {
    if (personelListesi.length === 0) {
      veritabaniniGuncelle();
    }
  }, []);

  // --- VERİ HAZIRLIĞI ---
  const kategoriListesi = useMemo(() => {
    return Object.keys(KATEGORILER).map(key => ({ ID: parseInt(key), ad: KATEGORILER[key] }));
  }, []);

  const hizmetListesi = useMemo(() => {
    return Object.keys(HIZMETLER).map(key => ({ ID: parseInt(key), ad: HIZMETLER[key] }));
  }, []);

  const personelListesiHazir = useMemo(() => {
    return personelListesi.map((p, index) => ({
      ID: p.ID || p.id || index,
      ad: p.Isim || p.isim || "Personel " + (index + 1)
    }));
  }, [personelListesi]);

  const rows = useMemo(() => ({
      row1: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      row2: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      row3: ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
      row4: ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
  }), []);

  // --- CALLBACKS ---
  const handleKeyPress = useCallback((key) => {
    setPlaka(prev => (prev.length < 10 ? prev + key : prev));
  }, []);

  const handleDelete = useCallback(() => {
    setPlaka(prev => prev.slice(0, -1));
  }, []);

  const getLabel = (type, ID) => {
      if (ID === null) return null;
      if (type === 'tur') return KATEGORILER[ID];
      if (type === 'hizmet') return HIZMETLER[ID];
      if (type === 'personel') {
          const p = personelListesiHazir.find(x => x.ID == ID);
          return p ? p.ad : null;
      }
      return null;
  };




  const handleSave = async () => {
    // 1. Validasyon
    if (!plaka || seciliTur === null || seciliHizmet === null || seciliPersonel === null) {
        setAlertConfig({
          visible: true,
          title: "Hata",
          message: "Lütfen tüm alanları doldurunuz.",
          type: 'error', // Kırmızı hata ikonu
          showCancel: false,
          confirmText: "Tamam",
          onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false }))
        });
      return;
    }

    // Personel ismini listeden bul (PHP 'personel' olarak ismi bekliyor)
    const secilenPersonelObj = personelListesiHazir.find(p => p.ID === seciliPersonel);
    const personelIsmi = secilenPersonelObj ? secilenPersonelObj.ad : "";

    // 2. Form Verisi Hazırlama (PHP $_POST ile uyumlu)
    const formData = new FormData();
    formData.append('plaka', plaka);
    formData.append('kategori', seciliTur); // PHP $kategori
    formData.append('hizmet', seciliHizmet); // PHP $hizmet
    formData.append('personel', personelIsmi); // PHP $personel
    formData.append('telefon', telefon);   // PHP $telefon
    formData.append('act', 'insert');      // PHP $action (Yeni kayıt için insert gönderiyoruz)

    const giris = new Date().toLocaleString('sv-SE', { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    }).replace(' ', ' ');

    try {
      // 3. API İsteği
      const response = await fetch('https://mirwax.durumrapor.com/app.php?action=AddPlate', {
        method: 'POST',
        body: formData,
      });

      const resData = await response.json();
      console.log("AddPlate API Yanıtı:", resData);

      // 4. PHP'den Gelen Yanıtları Yönet
      if (resData.status === "success" || resData.status === "update") {
        
        // --- 5. SOCKET SENKRONİZASYONU ---
        if (socketRef.current && socketRef.current.connected) {
          // Python tarafının listeyi anlık yenilemesi için gereken sinyaller
          socketRef.current.emit("senk", { 
            message: "addplate",
            plaka: plaka,
            personel: personelIsmi,
            kategori: seciliTur,
            hizmet: seciliHizmet,
            giris: giris
          });

          socketRef.current.emit("senk", {"message": "AddPlaka","Plaka":plaka,"Giris":giris});
          socketRef.current.emit("senk", {"message": "UpdatePlaka","Plaka":plaka,"Personel":personelIsmi,"Kategori":seciliTur,"Hizmet":seciliHizmet});
          setPlaka('');
          setSeciliTur(null);
          setSeciliHizmet(null);
          setSeciliPersonel(null);
          setTelefon('');
          verileriYenile();

        }

        Alert.alert("Başarılı", "Araç sisteme kaydedildi.", [
          { text: "Tamam", onPress: () => navigation.goBack() }
        ]);

      } else if (resData.status === "islemde") {
        Alert.alert("Uyarı", "Bu araç zaten içeride işlem görüyor.");
      } else if (resData.status === "tahsilat") {
        Alert.alert("Uyarı", "Bu araç bugün zaten işlem görmüş ve çıkış yapmış.");
      } else {
        Alert.alert("Hata", "Kayıt sırasında bir sorun oluştu.");
      }

    } catch (error) {
      console.error("Bağlantı Hatası:", error);
      Alert.alert("Bağlantı Hatası", "Sunucuya ulaşılamadı.");
    }
  };

  const renderModal = () => {
    let dataList = [], title = "";
    if (modalVisible === 'tur') { dataList = kategoriListesi; title = "Araç Türü"; }
    else if (modalVisible === 'hizmet') { dataList = hizmetListesi; title = "Hizmet Türü"; }
    else if (modalVisible === 'personel') { dataList = personelListesiHazir; title = "Personel Listesi"; }

    return (
      <Modal visible={!!modalVisible} transparent={true} animationType="fade">
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>{title}</Text>
              <TouchableOpacity onPress={() => setModalVisible(null)}>
                <Ionicons name="close-circle" size={28} color="#333" />
              </TouchableOpacity>
            </View>
            <FlatList
              data={dataList}
              keyExtractor={(item, index) => (item.ID ? item.ID.toString() : index.toString())}
              renderItem={({ item }) => (
                <TouchableOpacity 
                  style={styles.modalItem} 
                  onPress={() => {
                    if (modalVisible === 'tur') setSeciliTur(item.ID);
                    if (modalVisible === 'hizmet') setSeciliHizmet(item.ID);
                    if (modalVisible === 'personel') setSeciliPersonel(item.ID);
                    setModalVisible(null);
                  }}
                >
                  <Text style={styles.modalItemText}>{item.ad}</Text>
                  <Ionicons name="chevron-forward" size={18} color="#ccc" />
                </TouchableOpacity>
              )}
            />
          </View>
        </View>
      </Modal>
    );
  };

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <StatusBar barStyle="dark-content" />
      
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Ionicons name="arrow-back" size={24} color={COLORS.darkText} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Hızlı Kayıt</Text>
        <TouchableOpacity onPress={handleSave}>
          <Text style={styles.saveBtnText}>KAYDET</Text>
        </TouchableOpacity>
      </View>

      {/* Plaka Hero */}
      <View style={styles.heroContainer}>
        <View style={styles.plateFrame}>
            <Text style={styles.plateText}>{plaka || "34 XX ..."}</Text>
        </View>
      </View>

      {/* Scroll Form */}
      <ScrollView style={{flex: 1}} contentContainerStyle={{padding: 20}}>
          <View style={styles.row}>
              <View style={styles.halfCol}>
                  <Text style={styles.label}>ARAÇ TÜRÜ</Text>
                  <TouchableOpacity style={styles.selectBox} onPress={() => setModalVisible('tur')}>
                      <Text style={[styles.selectText, !seciliTur && {color: '#94a3b8'}]}>
                        {getLabel('tur', seciliTur) || "Seçiniz"}
                      </Text>
                  </TouchableOpacity>
              </View>
              <View style={styles.halfCol}>
                  <Text style={styles.label}>HİZMET</Text>
                  <TouchableOpacity style={styles.selectBox} onPress={() => setModalVisible('hizmet')}>
                      <Text style={[styles.selectText, !seciliHizmet && {color: '#94a3b8'}]}>
                        {getLabel('hizmet', seciliHizmet) || "Seçiniz"}
                      </Text>
                  </TouchableOpacity>
              </View>
          </View>

          <View style={styles.fullCol}>
              <Text style={styles.label}>PERSONEL</Text>
              <TouchableOpacity style={styles.selectBox} onPress={() => setModalVisible('personel')}>
                  <Text style={[styles.selectText, !seciliPersonel && {color: '#94a3b8'}]}>
                    {getLabel('personel', seciliPersonel) || "Seçiniz"}
                  </Text>
              </TouchableOpacity>
          </View>

          <View style={styles.fullCol}>
              <Text style={styles.label}>TELEFON</Text>
              <TextInput 
                style={styles.inputBox} 
                placeholder="05..." 
                keyboardType="phone-pad" 
                value={telefon} 
                onChangeText={setTelefon} 
              />
          </View>
      </ScrollView>

      {/* Klavye */}
      <View style={[styles.keyboardContainer, { paddingBottom: insets.bottom > 0 ? insets.bottom - 15 : 10 }]}>
          <View style={styles.keyRow}>
            {rows.row1.map(k => <KeyButton key={k} k={k} onPress={() => handleKeyPress(k)} />)}
          </View>
          <View style={styles.keyRow}>
            {rows.row2.map(k => <KeyButton key={k} k={k} onPress={() => handleKeyPress(k)} />)}
          </View>
          <View style={styles.keyRow}>
              <View style={{width: '4%'}} /> 
              {rows.row3.map(k => <KeyButton key={k} k={k} onPress={() => handleKeyPress(k)} />)}
              <View style={{width: '4%'}} />
          </View>
          <View style={styles.keyRow}>
              <View style={{width: '14%'}} /> 
              {rows.row4.map(k => <KeyButton key={k} k={k} onPress={() => handleKeyPress(k)} />)}
              <View style={{width: '4%'}} />
              <KeyButton k="DEL" widthPercentage={14} isDelete={true} onPress={handleDelete} />
          </View>
      </View>

            <CustomAlert 
              {...alertConfig} 
              onCancel={() => setAlertConfig(prev => ({ ...prev, visible: false }))} 
           />

      {renderModal()}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: COLORS.background },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', padding: 16, backgroundColor: '#fff', borderBottomWidth: 1, borderColor: '#e2e8f0' },
  headerTitle: { fontSize: 16, fontWeight: 'bold' },
  saveBtnText: { color: COLORS.primary, fontWeight: 'bold' },
  heroContainer: { padding: 20 },
  plateFrame: { backgroundColor: COLORS.plateBg, borderRadius: 12, padding: 15, alignItems: 'center', borderWidth: 2, borderColor: COLORS.plateAccent },
  plateText: { color: '#fff', fontSize: 32, fontWeight: 'bold', letterSpacing: 3, fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace' },
  row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 15 },
  halfCol: { width: '48%' },
  fullCol: { marginBottom: 15 },
  label: { fontSize: 11, fontWeight: 'bold', color: COLORS.secondaryText, marginBottom: 5 },
  selectBox: { backgroundColor: '#fff', height: 45, borderRadius: 8, borderWidth: 1, borderColor: COLORS.border, justifyContent: 'center', paddingHorizontal: 12 },
  selectText: { fontSize: 15, fontWeight: '500' },
  inputBox: { backgroundColor: '#fff', height: 45, borderRadius: 8, borderWidth: 1, borderColor: COLORS.border, paddingHorizontal: 12 },
  keyboardContainer: { backgroundColor: COLORS.keyboardBg, paddingTop: 10, paddingHorizontal: 4, borderTopLeftRadius: 15, borderTopRightRadius: 15 },
  keyRow: { flexDirection: 'row', justifyContent: 'center', marginBottom: 6 },
  keyButton: { height: 42, backgroundColor: '#fff', borderRadius: 6, justifyContent: 'center', alignItems: 'center', marginHorizontal: 2, elevation: 1 },
  keyText: { fontSize: 17, fontWeight: 'bold' },
  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'flex-end' },
  modalContent: { backgroundColor: '#fff', borderTopLeftRadius: 20, borderTopRightRadius: 20, maxHeight: '60%', paddingBottom: 20 },
  modalHeader: { flexDirection: 'row', justifyContent: 'space-between', padding: 15, borderBottomWidth: 1, borderColor: '#eee' },
  modalTitle: { fontWeight: 'bold', fontSize: 18 },
  modalItem: { flexDirection: 'row', justifyContent: 'space-between', padding: 16, borderBottomWidth: 1, borderColor: '#f1f5f9' },
  modalItemText: { fontSize: 16 }
});